import { FileInput, Form } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

type UpdateWatermarkImageParams = {
  fileData: string,
  fileObject: {
    type: string,
    name: string,
  },
  updateWatermarkImageFn: (watermarkImage: { fileData: string, fileObject: object })=> void,
}

const updateWatermarkImage = (params: UpdateWatermarkImageParams) => {
  const {
    fileData, fileObject, updateWatermarkImageFn,
  } = params

  if (!fileData) return

  const updateWatermarkImagePayload = {
    callbacks: {
      action: updateWatermarkImageFn,
    },
    entityParams: {
      filename: fileObject.name,
      watermark_image_file: fileData,
    },
    requestOptions: {
      include_agency_attachments: true,
      include_attachment_file: true,
    },
    toastText: 'Watermark setting updated',
  }

  // @ts-expect-error TS2345
  handleCallbackAction(updateWatermarkImagePayload)
}

interface WatermarkImageProps {
  callbacks:{
    updateWatermarkImage: (watermarkImage: { fileData: string, fileObject: object })=> void,
  },
}

const WatermarkImage = (props: WatermarkImageProps) => {
  const { callbacks: { updateWatermarkImage: updateWatermarkImageFn } } = props

  return (
    <Form.Field label="Upload Logo" marginTop="large">
      <FileInput
        input={{
          onChange: (
            fileData: string,
            fileObject: {
              type: string,
              name: string,
            },
          ) => updateWatermarkImage({
            fileData, fileObject, updateWatermarkImageFn,
          }),
          accept: 'image/*',
        }}
      />
    </Form.Field>
  )
}

export default WatermarkImage
